


























/* General */
import Vue from 'vue'
import Popper from 'popper.js'
import Clickoutside from 'element-ui/src/utils/clickoutside'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'Dropdown',

  directives: { Clickoutside },

  props: {
    /* Popper placements. See https://popper.js.org/docs/v1/#popperplacements--codeenumcode */
    placement: {
      type: String,
      default: 'bottom-start',
    },
    title: {
      type: String,
      default: 'Options',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    forceVisibility: {
      type: Boolean,
      default: false,
    },
    /* small = 100px, medium = 200px, large = 300px, extra-large = 360px, ginormous = 480px */
    popperMinWidthSize: {
      type: String,
      default: 'medium',
    },
  },

  data() {
    return {
      isOpen: false,
    }
  },

  computed: {
    modifiers(): Array<String> {
      const baseSelector = 'dropdown'
      const selectors = [baseSelector]

      if (this.isDisabled) {
        selectors.push(baseSelector + '--disabled')
      }

      return selectors
    },
  },

  watch: {
    /**
     * This will be used if the parent wants to force the close or open of the dropdown
     */
    forceVisibility: {
      immediate: true,
      handler(value: boolean) {
        this.isOpen = value
      },
    },
  },

  beforeUpdate() {
    /**
     * Set popper
     */
    const reference = this.$el.querySelector('.dropdown__trigger')
    const popper = this.$el.querySelector('.dropdown__popper')
    new Popper(reference, popper, {
      placement: this.placement as any,
    })
  },

  methods: {
    toggleDropdown() {
      if (!this.isDisabled) {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          this.$emit('open')
        } else {
          this.$emit('close')
        }
      }
    },

    handleClose() {
      if (this.isOpen) {
        this.$emit('close')
        this.isOpen = false
      }
    },
  },
})
